import { EnumMapper } from "../../../common/tables/etc/EnumMapper";
import { ShopifyProductForAdmin } from "../../../../../common/tables/shopify/ShopifyProductForAdmin";
import { EnumResolver } from "../../../common/tables/etc/EnumResolver";

export class ShopifyProductEnumResolver extends EnumResolver<ShopifyProductForAdmin> {
    public resolveEnum(_columnName: keyof ShopifyProductForAdmin): EnumMapper {
        return {} as EnumMapper;
    }
}
